import { z } from 'zod'
import { type AppGroup } from '../../models/AppGroup'
import { AppSource } from '../../models/App'
import { BaseAppDTO, mapBaseAppToDTO, mapDTOToBaseApp } from './BaseAppDTO'

export const AppGroupDTO = z.object({
  source: z.nativeEnum(AppSource),
  apps: z.array(BaseAppDTO)
})

export type AppGroupDTO = z.infer<typeof AppGroupDTO>

export function mapAppGroupToDTO (model: AppGroup): AppGroupDTO {
  return {
    source: model.source,
    apps: model.apps.map(mapBaseAppToDTO)
  }
}

export function mapDTOToAppGroup (dto: AppGroupDTO): AppGroup {
  return {
    source: dto.source,
    apps: dto.apps.map(mapDTOToBaseApp)
  }
}
